import React from 'react';
import { CTAButton } from './CTAButton';
export function IncludedSection() {
  const books = [{
    emoji: '📘',
    title: '100 Citas Mamá e Hija',
    desc: 'Momentos uno a uno para hablar, reír y crear un vínculo que ella va a recordar toda su vida.',
    color: 'border-blue-500',
    bg: 'bg-blue-50'
  }, {
    emoji: '📗',
    title: '100 Citas Mamá e Hijo',
    desc: 'Actividades para conectar desde el juego, la escucha y el amor. Porque él también necesita esos momentos con vos.',
    color: 'border-green-500',
    bg: 'bg-green-50'
  }, {
    emoji: '📙',
    title: '100 Citas Papá e Hija',
    desc: 'Espacios únicos para reforzar seguridad, confianza y cercanía. Ella necesita saber que papá siempre está.',
    color: 'border-orange-500',
    bg: 'bg-orange-50'
  }, {
    emoji: '📕',
    title: '100 Citas Papá e Hijo',
    desc: 'Propuestas para compartir tiempo real y crear recuerdos que van a definir quién es él como persona.',
    color: 'border-red-500',
    bg: 'bg-red-50'
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <div data-id="element-90">
          <div className="text-center mb-12" data-id="element-91">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-92">
              📚 ESTO ES TODO LO QUE RECIBÍS HOY
            </h2>
            <p className="text-gray-500 italic" data-id="element-93">
              Todo lo que necesitás para transformar la relación con tus hijos.
            </p>
            <div className="w-24 h-2 bg-red-600 mx-auto rounded-full mt-4" data-id="element-94"></div>
          </div>

          <div className="space-y-6 mb-12" data-id="element-95">
            {books.map((book, idx) => <div key={idx} className={`flex flex-col md:flex-row items-center md:items-start gap-6 p-6 rounded-2xl border-2 ${book.color} ${book.bg} shadow-lg`} data-id="element-96">
                <div className="text-6xl md:text-7xl" data-id="element-97">{book.emoji}</div>
                <div className="text-center md:text-left flex-1" data-id="element-98">
                  <h3 className="text-2xl font-black text-gray-900 mb-2" data-id="element-99">
                    {book.title}
                  </h3>
                  <p className="text-lg text-gray-700 mb-4 font-medium" data-id="element-100">
                    {book.desc}
                  </p>
                  <p className="inline-block bg-white px-4 py-1 rounded-full text-sm font-bold text-gray-500 border border-gray-200 shadow-sm" data-id="element-101">
                    Valor estimado:{' '}
                    <span className="line-through" data-id="element-102">$10.000</span>
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-yellow-100 border-2 border-yellow-400 p-6 rounded-xl text-center mb-10 shadow-md" data-id="element-103">
            <p className="text-xl md:text-2xl font-black text-gray-900" data-id="element-104">
              👉 Un solo pack.
              <br className="md:hidden" data-id="element-105" /> 👉 Todos los vínculos padres e hijos
              cubiertos.
            </p>
            <p className="text-gray-600 italic mt-2" data-id="element-106">
              Porque cada hijo merece momentos únicos con mamá y con papá.
            </p>
          </div>

          <CTAButton text="🔥 QUIERO ESTOS MOMENTOS CON MIS HIJOS" data-id="element-107" />
        </div>
      </div>
    </section>;
}